import {
  GET_REFERRALS,
  GET_SECTORS,
  GET_SATCONTENT,
  GET_SATCONTENTACTION,
  GET_NOTIFICATIONS,
  GET_NOTIFICATIONSACTION,
  GET_FOOTER,
  GET_CONTENT

} from "./mutation-types";
import { dataService } from "../services/data.service";

const state = () => ({
  referrals: [],
  sectors: [],
  satContent: {},
  notifications: {},
  footerNav:[],
  content: {},
});

const mutations = {
  [GET_REFERRALS](state, referrals) {
    state.referrals.push(referrals);
  },
  [GET_SECTORS](state, sectors) {
    state.sectors.push(sectors);
  },
  [GET_SATCONTENT](state, satContent) {
    state.satContent = satContent;
  },

  [GET_NOTIFICATIONS](state, notifications) {
    state.notifications = notifications;
  },
  [GET_FOOTER](state, footerNav) {
    state.footerNav.push(footerNav);
  },
  [GET_CONTENT](state, content) {
    state.content = content;
  },
};

const actions = {
  async getReferrals({ commit }) {
    //const referrals = await dataService.getReferrals();
    const result = await dataService.getToolsContent(); 
    if (result && result.HowDidYouHearAboutUs){
      var referrals = result.HowDidYouHearAboutUs.map((ref) =>{
        return { value: ref};
      });
      commit(GET_REFERRALS, referrals);
      return referrals;
    } 
  },

  async getSectors({ commit }) {
    //const sectors = await dataService.getSectors();
    const result = await dataService.getToolsContent(); 
    if (result && result.Sectors) {
      var sectors = result.Sectors.map((sector) =>{
        return { value: sector};
      });

      commit(GET_SECTORS, sectors);
      return sectors;
    }
  },
  async [GET_SATCONTENTACTION]({ commit }) {
    const satContent = await dataService.getSatContent();
    commit(GET_SATCONTENT, satContent);
  },

  async [GET_NOTIFICATIONSACTION]({ commit }) {
    const notifications = await dataService.getNotificationsData();
    commit(GET_NOTIFICATIONS, notifications);
  },
  async getContent({ commit }) {
    const content = await dataService.getContent();
    commit(GET_CONTENT, content);
  },
  async getFooterNav({ commit }) {
    const result = await dataService.getFooterNav();
    if(result && result.Items){
      var footer = result.Items.map((x) =>{
        return { pageName: x.PageName,
        url:x.PageUrl};
      });
    commit(GET_FOOTER, footer);
    return footer;
    }
  }
};

const getters = {
  getReferrals: state => state.satContent.HowDidYouHearAboutUs,
  getSectors: state => state.satContent.Sectors
};

export const util = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
